import { defineMessages } from "react-intl";

const messages = defineMessages({
  actionColor: {
    id: "leadFinder.resultsModal.action.color",
    defaultMessage: "Assigned color",
    description: "Lead Finder - Assigned color step title",
  },
  actionGroup: {
    id: "leadFinder.resultsModal.action.group",
    defaultMessage: "Added to {count} {count, plural, one {group} other {groups}}",
    description: "Lead Finder - Added to groups step title",
  },
  actionRoutes: {
    id: "leadFinder.resultsModal.action.route",
    defaultMessage: "Added to {count} {count, plural, one {route} other {routes}}",
    description: "Lead Finder - Added to routes step title",
  },
  errorAddingRoute: {
    id: "leadFinder.resultsModal.errorAddingRoute",
    defaultMessage: "Unable to add to route “{name}”: {error}",
    description: "Lead Finder - Error adding route",
  },
  newRouteName: {
    id: "leadFinder.resultsModal.newRouteName",
    defaultMessage: "{name} [NEW]",
    description: "Lead Finder - New route name",
  },
  openGroup: {
    id: "leadFinder.resultsModal.openGroup",
    defaultMessage: "Open group",
    description: "Lead Finder - Open group tooltip",
  },
  openRoute: {
    id: "leadFinder.resultsModal.openRoute",
    defaultMessage: "Open route",
    description: "Lead Finder - Open route tooltip",
  },
  returnButton: {
    id: "leadFinder.resultsModal.return",
    defaultMessage: "Return to Map",
    description: "Lead Finder - Return to Map",
  },
});

export default messages;
